import React, { Fragment } from 'react';
import { Intro, Slideshow, slideTextTypes, slideTypes } from 'dea-core';
import img1 from '../../assets/images/U1-T1-06A_R.svg';
import img2 from '../../assets/images/U1-T1-06B_D.svg';
import img3 from '../../assets/images/U1-T1-06C_L.svg';
import audio1 from '../../assets/vo/Opioid-M-One-07.mp3';
import audio2 from '../../assets/vo/Opioid-M-One-7A.mp3';
// import audio2 from '../../assets/vo/Opioid-M-One-07A.mp3'; old file but at least it sounds reasonable.
import audio3 from '../../assets/vo/Opioid-M-One-07B-NEW.mp3';

const slides = [
  {
    SlideType: slideTypes.HorizontalPan,
    panDirection: 'right',
    duration: 15,
    image: img1,
    text: {
      type: slideTextTypes.BottomText,
      text: 'An Over-Prescription of Opioids'
    },
    vo: {
      sources: [
        {
          src: audio1
        }
      ],
      transcript:
        'The first of three major contributors to the opioid epidemic was the over-prescription of opioids that occurred from 1991 to 2011. Subsequently, unused pills were kept in medicine cabinets.'
    }
  },
  {
    SlideType: slideTypes.VerticalPan,
    panDirection: 'up',
    duration: 19,
    image: img2,
    text: {
      type: slideTextTypes.BottomText,
      text: 'An Increase in Heroin Production'
    },
    vo: {
      sources: [
        {
          src: audio2
        }
      ],
      transcript:
        'The second major contributor, from 2005 to present day, is the increase in heroin production. An increase in heroin production decreases costs and provides an alternative to getting a medical doctor to write an opioid prescription and have it filled at a pharmacy.'
    }
  },
  {
    SlideType: slideTypes.HorizontalPan,
    panDirection: 'left',
    duration: 11.5,
    image: img3,
    text: {
      type: slideTextTypes.BottomText,
      text: 'An Increase in Fentanyl Production'
    },
    vo: {
      sources: [
        {
          src: audio3
        }
      ],
      transcript:
        'And the third major contributor is the increase in fentanyl production by clandestine labs around the world that began in 2013 and continues today.'
    }
  }
];

export default {
  title: 'How did the Opioid Epidemic Evolve?',
  path: '/explain/opioid-epidemic-evolve',
  content: (
    <Fragment>
      <Intro
        title="How did the opioid epidemic evolve?"
        direction="Select the play button below to begin."
      />
      <Slideshow slides={slides} />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/explain/OpioidEpidemicEvolution.js